function isFunctionalConsentGiven() {
    return typeof CookieInformation !== 'undefined'
        && CookieInformation.getConsentGivenFor('cookie_cat_functional');
}

function updateChatCtas() {
    document.querySelectorAll('.contact-us-component').forEach((wrapper) => {
        const accepted = wrapper.querySelector('.js-chat-cta-accepted');
        const consentPrompt = wrapper.querySelector('.js-chat-cta-consent');
        if (!accepted || !consentPrompt) {
            return;
        }

        const consent = isFunctionalConsentGiven();
        accepted.classList.toggle('hide', !consent);
        consentPrompt.classList.toggle('hide', consent);
    });
}

let awaitingConsentFromChatCta = false;

// Cookie Information dispatches this on window (see the LiveChat init script on
// this site, which relies on the exact same pattern), not on document.
window.addEventListener('CookieInformationConsentGiven', () => {
    updateChatCtas();

    const consentJustGivenFromChatCta = awaitingConsentFromChatCta && isFunctionalConsentGiven();
    awaitingConsentFromChatCta = false;

    if (!consentJustGivenFromChatCta) {
        return;
    }

    document.querySelectorAll('.js-chat-cta-accepted').forEach((link) => {
        link.click();
    });
});

document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.js-chat-cta-consent')) {
        return;
    }

    updateChatCtas();

    document.querySelectorAll('.js-chat-cta-consent').forEach((consentButton) => {
        consentButton.addEventListener('click', (event) => {
            event.preventDefault();

            if (window.CookieConsent && typeof window.CookieConsent.renew === 'function') {
                awaitingConsentFromChatCta = true;
                window.CookieConsent.renew();
            } else {
                console.warn('Cookie Information SDK is not fully loaded on the page yet.');
            }
        });
    });
});
